var _ellipse, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 47,
    viewBox: "0 0 32 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 42.4516,
    rx: 9.09677,
    ry: 4.54839,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6612 15.1613C30.6612 17.1565 29.9328 19.8364 28.7546 22.7717C27.5817 25.694 25.9831 28.8206 24.2871 31.6922C22.5907 34.5646 20.8047 37.1684 19.2617 39.0477C18.489 39.9888 17.7872 40.7359 17.1964 41.243C16.9007 41.4967 16.6437 41.6808 16.4288 41.7991C16.2068 41.9213 16.0686 41.9516 15.9999 41.9516C15.9312 41.9516 15.7931 41.9213 15.5711 41.7991C15.3561 41.6808 15.0991 41.4967 14.8035 41.243C14.2126 40.7359 13.5109 39.9888 12.7382 39.0477C11.1951 37.1684 9.40913 34.5646 7.71269 31.6922C6.01672 28.8206 4.41815 25.694 3.24518 22.7717C2.06703 19.8364 1.33862 17.1565 1.33862 15.1613C1.33862 7.06408 7.90271 0.5 15.9999 0.5C24.0971 0.5 30.6612 7.06408 30.6612 15.1613Z",
    fill: "#F9D948",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9999,
    cy: 15.1613,
    r: 6.06452,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMarker);
export default __webpack_public_path__ + "static/media/selectedMarker.0d4008541b31d51ced75fbe15e900ec4.svg";
export { ForwardRef as ReactComponent };